
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bots/listings/[id]",
      function () {
        return require("private-next-pages/bots/listings/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bots/listings/[id]"])
      });
    }
  